const THIRD_PARTY_SOURCE_PRODUCTS = [
	'github',
	'google',
	'msteams',
	'outlook',
	'sharepoint',
	'slack',
] as const;

/**
 * Action keys are owned by tool providers and use the connector identifier as
 * their prefix. Keep the classification allowlisted so unknown or first-party
 * tools cannot silently start contributing to third-party MAU.
 */
export const getThirdPartySourceProductFromActionKey = (
	actionKey: string | undefined,
): (typeof THIRD_PARTY_SOURCE_PRODUCTS)[number] | null => {
	if (!actionKey) {
		return null;
	}

	const normalizedActionKey = actionKey.toLowerCase();
	return (
		THIRD_PARTY_SOURCE_PRODUCTS.find((sourceProduct) =>
			normalizedActionKey.startsWith(sourceProduct),
		) ?? null
	);
};
